import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RgbProvider } from '../rgb/rgb';


@Injectable()
export class AuxiliarReportesProvider {

  constructor(public http: HttpClient, public color: RgbProvider) {
  }


  rowTituloReporte() {
    var row = document.createElement('ion-row');
    row.setAttribute("id", "row-titulo-reporte");
    row.setAttribute("class", "row");
    return row;
  }
  crearRow(i) {
    var row = document.createElement('ion-row');
    row.setAttribute("id", "" + i);
    row.setAttribute("class", "row contenedorseccion");
    return row;
  }

  contenedoresCard(numcontenedores, seccionx) {
    let contenedores = "";
    //generar contenedores para tablas y gráficas
    for (let i = 0; i < numcontenedores.length; i++) {
      if (numcontenedores[i].tipo == "table") {
        const filas = Array.isArray(numcontenedores[i].contenido) ? numcontenedores[i].contenido : [];
        const primeraFila = filas.length && Array.isArray(filas[0]) ? filas[0] : [];
        let clasedimension = "";
        if (primeraFila.length <= 4) { clasedimension = " tabla-chica"; }
        else if (primeraFila.length > 4 && primeraFila.length <= 9) {
          clasedimension = " tabla-media";
        }
        else if (primeraFila.length > 9 && primeraFila.length <= 12) {
          clasedimension = " tabla-grande";
        }
        else if (primeraFila.length > 12 && primeraFila.length <= 16) {
          clasedimension = " tabla-grande2";
        }
        else if (primeraFila.length > 16 && primeraFila.length <= 20) {
          clasedimension = " tabla-grande3";
        }
        else if (primeraFila.length > 20) {
          clasedimension = " tabla-full";
        }
       

        contenedores = contenedores + '<div  class="area-contenido-reportes ' + clasedimension + '" id="' + "contenedor" + seccionx + i + '">div de contenido</div>';
      }
      if (numcontenedores[i].tipo != "table") {
        let comparador = numcontenedores[i].contenido.length;
        let clasedimension = "";

        if (comparador <= 4) { clasedimension = "chart-chico" }
        if (comparador > 4 && comparador <= 8) { clasedimension = "chart-mediano" }
        if (comparador > 8) { clasedimension = "chart-grande" }
        contenedores = contenedores + '<div class="area-contenido-reportes ' + clasedimension + '"><ion-row class="row" id="' + "contenedor" + seccionx + i + '"></ion-row></div>';
      }
    }
    return contenedores;
  }

  generarTabla(contenidos) {
    const filas = contenidos && Array.isArray(contenidos.contenido) ? contenidos.contenido : [];
    const tieneEncabezadoHorizontal = contenidos && String(contenidos.hh) === '1';
    const tieneEncabezadoVertical = contenidos && String(contenidos.hv) === '1';
    const titulo = this.escaparHtml(contenidos && contenidos.titulo);
    let tabla = '<div class="report-table">';
    tabla += '<div class="report-table-actions"><ion-icon class="icono icon icon-ios ion-md-download" name="md-download" role="img" aria-label="download"></ion-icon></div>';
    tabla += '<div class="report-table-scroll"><table class="report-table-element">';

    if (tieneEncabezadoHorizontal && filas.length) {
      tabla += '<thead><tr>';
      tabla += filas[0].map((celda) => '<th scope="col">' + this.escaparHtml(celda) + '</th>').join('');
      tabla += '</tr></thead>';
    }

    tabla += '<tbody>';
    const inicio = tieneEncabezadoHorizontal ? 1 : 0;
    for (let fila = inicio; fila < filas.length; fila++) {
      const celdas = Array.isArray(filas[fila]) ? filas[fila] : [];
      tabla += '<tr>';
      for (let columna = 0; columna < celdas.length; columna++) {
        const esEncabezado = tieneEncabezadoVertical && columna === 0;
        tabla += esEncabezado ? '<th scope="row">' : '<td>';
        tabla += this.escaparHtml(celdas[columna]);
        tabla += esEncabezado ? '</th>' : '</td>';
      }
      tabla += '</tr>';
    }
    tabla += '</tbody></table></div>';
    tabla += '<div class="report-table-footer" title="' + titulo + '"><span>' + titulo + '</span></div>';
    return tabla + '</div>';
  }

  private escaparHtml(valor: any): string {
    return String(valor === null || valor === undefined ? '' : valor)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  contenedoresChart(i, j, piedegrafica) {
    let row1 = '<ion-row class="row" justify-content-center align-items-center>';
    let row2 = '</ion-row>';
    let contenidografica = "";
    const titulo = this.escaparHtml(piedegrafica);
    contenidografica = contenidografica + '<ion-row class="row chart-actions" justify-content-end align-items-center><ion-icon class="icono chart-download icon icon-ios ion-md-download" name="md-download" role="img" aria-label="Descargar gráfica" ng-reflect-name="md-download"></ion-icon>' + row2;
    contenidografica = contenidografica + '<ion-row class="row">' +
      '<div class="area-chart-reportes" id="chart' + i + j + '"></div>' + row2;
    contenidografica = contenidografica + row1 + '<label class="pie-tabla-grafica" title="' + titulo + '">' + titulo + '</label>'
    return contenidografica;
  }

  editarGrafica(chart, tipo) {
    let grafica: any;
    let getColor: any;
    let getHover: any;
    let conjuntos = [];
    let lista_labels: any;

    if (tipo == "pie" || tipo == 'doughnut') { //dona y pay
      getColor = [];
      getHover = [];
      let datos = [];
      lista_labels = this.get_lista_labels(chart.contenido);
      for (let i = 0; i < chart.contenido.length; i++) {
        let color = this.color.rgbReporte(i);
        getColor[i] = color.color;
        getHover[i] = color.bgcolor;
        datos[i] = chart.contenido[i][1];
      }
      conjuntos.push(
        {
          label: "texto rand",
          data: datos,
          backgroundColor: getColor,
          hoverBackgroundColor: getHover
        }
      );
      grafica = this.grafica(tipo, lista_labels, conjuntos);
    }

    else if (tipo == "simpleBar" || tipo == "simpleHorizontalBar") { // barras simples     
      if (tipo == "simpleBar") tipo = "bar";
      if (tipo == "simpleHorizontalBar") tipo = "horizontalBar";
      for (let x = 0; x < chart.contenido.length; x++) {
        let color = this.color.rgbReporte(x);
        getColor = color.color;
        getHover = color.bgcolor;
        lista_labels = this.get_lista_labels(chart.contenido);
        conjuntos.push({
          label: chart.contenido[x][0],
          backgroundColor: getColor,
          borderColor: getColor,
          data: this.get_lista_data(chart.contenido, x),
          hoverBackgroundColor: getHover,
        });
      }
      grafica = this.grafica(tipo, lista_labels, conjuntos);
    }
    else { grafica = ""; }
    return grafica;
  }

  get_lista_labels(chart) {
    let contiene = [];
    for (let x = 0; x < chart.length; x++) {
      contiene[x] = chart[x][0];
    }
    return contiene;
  }

  get_lista_data(chart, pos) {
    let contiene = [];
    for (let x = 0; x < chart.length; x++) {
      if (x == pos) {
        contiene[x] = chart[x][1];
      }
      else {
        contiene[x] = "0";
      }
    }
    return contiene;
  }

  opcionesStacked() {
    let opciones = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: { top: 6, right: 10, bottom: 2, left: 4 }
      },
      legend: {
        display: false
      },
      tooltips: {
        backgroundColor: 'rgba(32, 42, 51, 0.92)',
        titleFontSize: 13,
        bodyFontSize: 13,
        xPadding: 10,
        yPadding: 8
      },
      "scales": {
        xAxes: [{ stacked: true, gridLines: { color: 'rgba(32, 42, 51, 0.08)' } }],
        yAxes: [{ stacked: true, gridLines: { color: 'rgba(32, 42, 51, 0.10)' }, ticks: { beginAtZero: true } }]
      }
    };
    return opciones;
  }

  grafica(tipo, listalabels, conjuntos) {
    let grafica: any;
    if (tipo == "doughnut" || tipo == "pie") {
      grafica = {
        type: tipo,
        data: {
          labels: listalabels,
          datasets: conjuntos
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: { top: 4, right: 8, bottom: 2, left: 8 }
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 12,
              fontSize: 11,
              padding: 10
            }
          },
          tooltips: {
            backgroundColor: 'rgba(32, 42, 51, 0.92)',
            titleFontSize: 13,
            bodyFontSize: 13,
            xPadding: 10,
            yPadding: 8
          }
        }
      };
    }
    else {
      let nuevaopcion: any;
      nuevaopcion = this.opcionesStacked();
      grafica = {
        type: tipo,
        data: {
          labels: listalabels,
          datasets: conjuntos
        },
        "options": nuevaopcion
      };

    }
    return grafica;
  }

  ordenarExcel(libro) {
    let nuevo = [];
    for (let i = 0; i < libro.length; i++) {
      let hoja1 = [];
      for (let j = 1; j < libro[i].hoja.length; j++) {
        let valor = '';

        for (let titulo = 0; titulo < libro[i].hoja[0].length; titulo++) {
          valor = valor + '"' + libro[i].hoja[0][titulo] + '":"' + libro[i].hoja[j][titulo] + '"';
          if (titulo < libro[i].hoja[0].length - 1) {
            valor = valor + ',';
          }
        }
       
        let x = '{' + valor + '}';
        hoja1.push(JSON.parse(x));
      }

      nuevo.push({
        titulohoja: libro[i].titulohoja,
        hoja: hoja1
      });
    }
    return nuevo;
  }

}



// WEBPACK FOOTER //
// ./src/providers/auxiliar-reportes/auxiliar-reportes.ts